import * as RadixAccordion from '@radix-ui/react-accordion';
import { useEffect, useState } from 'react';

import { styled } from 'styled-components';
import { useScene } from '../../../hooks';
import { SidebarAccordionItem } from './SidebarAccordionItem';

export const SidebarAccordion = ({ pseudoclass }: { pseudoclass: string }) => {
  const [openItems, setOpenItems] = useState<string[]>([]);

  const scene = useScene();
  const launcherStates = scene.launcherStates;

  function getKeysWithTrueValues(obj: any) {
    const keys = Object.keys(obj);
    const trueKeys = keys.filter((key) => obj[key] === true);
    return trueKeys;
  }
  useEffect(() => {
    const statesArr = getKeysWithTrueValues(launcherStates);
    setOpenItems(statesArr);
  }, [launcherStates]);

  const toggleItem = (item: string) => {
    if (openItems.includes(item)) {
      setOpenItems(openItems.filter((i) => i !== item));
    } else {
      setOpenItems([...openItems, item]);
    }
  };

  const overflowHidden = (item: string) => !openItems.includes(item);

  return (
    <Container>
      <RadixAccordion.Root
        className="AccordionRoot"
        type="multiple"
        value={openItems}
      >
        {/* <SidebarAccordionItem
          pseudoclass={pseudoclass}
          toggleItem={toggleItem}
          item="doesAppDirExist"
          iconClassName="icon-dir"
          name="Does App Dir Exist"
          overflowHidden={overflowHidden('doesAppDirExist')}
        /> */}
        <SidebarAccordionItem
          pseudoclass={pseudoclass}
          toggleItem={toggleItem}
          item="isAppInstalled"
          iconClassName="icon-state-installed"
          name="Is App Installed"
          overflowHidden={overflowHidden('isAppInstalled')}
        />
        <SidebarAccordionItem
          pseudoclass={pseudoclass}
          toggleItem={toggleItem}
          item="doesAppNeedRepair"
          iconClassName="icon-state-need-repair"
          name="Does App Need Repair"
          overflowHidden={overflowHidden('doesAppNeedRepair')}
        />
        <SidebarAccordionItem
          pseudoclass={pseudoclass}
          toggleItem={toggleItem}
          item="isAppUpdateAvailable"
          iconClassName="icon-state-update-available"
          name="Is App Update Available"
          overflowHidden={overflowHidden('isAppUpdateAvailable')}
        />
        <SidebarAccordionItem
          pseudoclass={pseudoclass}
          toggleItem={toggleItem}
          item="doesAppOngoingTaskExist"
          iconClassName="icon-state-any-task"
          iconSize={20}
          name="Does App Any Task Exist"
          overflowHidden={overflowHidden('doesAppOngoingTaskExist')}
        />
        <SidebarAccordionItem
          pseudoclass={pseudoclass}
          toggleItem={toggleItem}
          item="doesAppOngoingInstallTaskExist"
          iconClassName="icon-state-install-task"
          iconSize={20}
          name="Does App Ongoing Install Task Exist"
          overflowHidden={overflowHidden('doesAppOngoingInstallTaskExist')}
        />
        <SidebarAccordionItem
          pseudoclass={pseudoclass}
          toggleItem={toggleItem}
          item="doesAppOngoingUpdateTaskExist"
          iconClassName="icon-state-update-task"
          iconSize={20}
          name="Does App Ongoing Update Task Exist"
          overflowHidden={overflowHidden('doesAppOngoingUpdateTaskExist')}
        />
        <SidebarAccordionItem
          pseudoclass={pseudoclass}
          toggleItem={toggleItem}
          item="doesAppOngoingUninstallTaskExist"
          iconClassName="icon-state-uninstall-task"
          iconSize={20}
          name="Does App Ongoing Uninstall Task Exist"
          overflowHidden={overflowHidden('doesAppOngoingUninstallTaskExist')}
        />
        <SidebarAccordionItem
          pseudoclass={pseudoclass}
          toggleItem={toggleItem}
          item="doesAppOngoingRepairTaskExist"
          iconClassName="icon-state-repair-task"
          iconSize={20}
          name="Does App Ongoing Repair Task Exist"
          overflowHidden={overflowHidden('doesAppOngoingRepairTaskExist')}
        />
        {/* <SidebarAccordionItem
          pseudoclass={pseudoclass}
          toggleItem={toggleItem}
          item="doesAppOngoingMoveTaskExist"
          iconClassName="icon-state-move-task"
          iconSize={20}
          name="Does App Ongoing Move Task Exist"
          overflowHidden={overflowHidden('doesAppOngoingMoveTaskExist')}
        /> */}
        {/* <SidebarAccordionItem
          pseudoclass={pseudoclass}
          toggleItem={toggleItem}
          item="doesAppLastTaskFailed"
          iconClassName="icon-state-last-task-failed"
          name="Does App Last Task Failed"
          overflowHidden={overflowHidden('doesAppLastTaskFailed')}
        /> */}
      </RadixAccordion.Root>
    </Container>
  );
};

const Container = styled.div`
  .AccordionRoot {
    .AccordionItem {
      margin-top: 1px;

      & > h3 {
        margin: 0;
      }
    }

    .AccordionItem:first-child {
      margin-top: 0;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    .AccordionItem:last-child {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    .AccordionHeader {
      display: flex;
    }

    .AccordionTrigger {
      padding: 0 10px;
      height: 30px;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 15px;

      overflow: hidden;
    }
    .AccordionTrigger[data-state='open'] {
      background-color: var(--panel-bg-color);
    }

    .AccordionTriggerText {
      display: flex;
      align-items: center;

      transition: color 0.3s ease;
      color: var(--text-color-secondary);
      font-size: 12px;
      font-weight: 400;
      white-space: nowrap;
      overflow: hidden;
    }
    .AccordionTriggerText > span {
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .AccordionTrigger[data-state='open'] > .AccordionTriggerText {
      color: var(--text-color);
    }
    .AccordionTriggerText > i {
      margin-right: 5px;
      font-size: 15px;
    }

    .AccordionTrigger:hover {
      background-color: var(--panel-bg-color-hover);
    }

    /* .AccordionContent {
  overflow: hidden;
} */
    .AccordionContent[data-state='open'] {
      animation: slideDown 300ms cubic-bezier(0.87, 0, 0.13, 1);
    }
    .AccordionContent[data-state='closed'] {
      animation: slideUp 300ms cubic-bezier(0.87, 0, 0.13, 1);
    }

    .AccordionContentText {
      padding: 5px;

      border: 1px solid var(--panel-bg-color-hover);
      border-top: none;
      border-radius: 15px;
    }

    .AccordionChevron {
      color: var(--text-color-secondary);
      transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);
    }
    .AccordionTrigger[data-state='open'] > .AccordionChevron {
      transform: rotate(180deg);
    }
  }

  @keyframes slideDown {
    from {
      height: 0;
    }
    to {
      height: var(--radix-accordion-content-height);
    }
  }

  @keyframes slideUp {
    from {
      height: var(--radix-accordion-content-height);
    }
    to {
      height: 0;
    }
  }
`;
